import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { setCockpitAttentionGrouping } from '../../../model/financialCockpitSlice'
import { selectCockpitAttentionLevel } from '../../../model/selectors'
import type { TCockpitAttentionGrouping } from '../../../model/types'

/**
 * How the level the drill-down stands on is grouped, and what else it may be grouped by. The pick
 * applies to that level only; the header's switcher and the full-screen view share it.
 */
export const useAttentionGrouping = () => {
  const dispatch = useAppDispatch()
  const level = useSelector(selectCockpitAttentionLevel)

  const selectGrouping = useCallback(
    (next: TCockpitAttentionGrouping) => dispatch(setCockpitAttentionGrouping(next)),
    [dispatch]
  )

  return {
    grouping: level?.grouping ?? null,
    options: level?.options ?? [],
    /** Name of the group the level sits in, e.g. `Germany`; `null` right under the status. */
    scopeName: level?.steps[level.steps.length - 1]?.node.name ?? null,
    selectGrouping,
  }
}
